<template>
    <div class="animated fadeIn">
        <DynamicList
                ref="dynamicCardList"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                :onRetrieve="onRetrieve"
                root="/report/commerce-payments"
                :searchArgs="searchArgs">

            <slot slot="afterList">
                <hr/>
                <div v-if="dataCharts !== false" class="card-group animated fadeIn">
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{dataCharts.count}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Nombre de paiements")}}</small>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Currency.format(dataCharts.total)}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Total")}}</small>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Currency.format(dataCharts.totalTaxes)}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Taxes")}}</small>
                        </div>
                    </div>
                </div>
            </slot>

            <slot slot="afterSearchForm">

                <b-button @click="$refs.modalExport.open = true" variant="light" class="mb-3">
                    {{Core.Definition.getDefinition("Exporter sous format ...")}}
                </b-button>
                <ModalExport
                        ref="modalExport"
                        root="/report/commerce-payments"
                        :formStructure="{
                                rows: [
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportFormat'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                     {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'id'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'status'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'date'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'method'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'purchaseType'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'purchaseId'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'paymentAttempt'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'referenceNumber'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'total'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                fields: [
                                    {
                                        id: 'exportFormat',
                                        type: 'select',
                                        options: Core.Export.formatOptions(),
                                        label: Core.Definition.getDefinition('Format'),
                                        value: null,
                                        onSelect: function() {}
                                    },
                                    {
                                        id: 'exportTitle',
                                        type: 'text',
                                        label: Core.Definition.getDefinition('Titre'),
                                        value: '',
                                        required: true
                                    },
                                    {
                                        id: 'id',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('ID'),
                                        value: true,
                                        export: 'id',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'status',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('État'),
                                        value: true,
                                         export: 'status',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'date',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Date'),
                                        value: true,
                                        export: 'date',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'method',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Méthode de paiement'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'method',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'purchaseId',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('ID de l\'achat'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'purchaseId',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'referenceNumber',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Numéro de référence'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'referenceNumber',
                                        onChange: function() {}
                                    },

                                    {
                                        id: 'purchaseType',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Type d\'achat'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'purchaseType',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'paymentAttempt',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Tentatives échouées'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'paymentAttempt',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'total',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Total'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'total',
                                        onChange: function() {}
                                    }
                                ]}"

                @onSubmit="onExport">
                </ModalExport>
            </slot>
        </DynamicList>

    </div>
</template>

<script>
    import DynamicList from '../../../../components/DynamicList'
    import CardChartBar from '../../../../components/CardChartBar'
    import ModalExport from '../../../../components/ModalExport'
    export default {
        name: 'ReportCommercePayment',
        components: {
            DynamicList,
            CardChartBar,
            ModalExport
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataSearchArgs: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('État'),
                        key: 'status',
                        type: 'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date'),
                        key: 'date',
                        type: 'date',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Numéro de référence'),
                        key: 'referenceNumber',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('ID de l\'achat'),
                        key: 'purchaseId',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Type de l\'achat'),
                        key: 'purchaseType',
                        type: 'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Méthode'),
                        key: 'method',
                        type: 'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Montant payé'),
                        key: 'total',
                        type: 'currency',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Tentatives échouées'),
                        key: 'paymentAttempt',
                        type: 'number',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'start'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'end'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'status'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'purchaseId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'purchaseType'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'referenceNumber'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'method'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'branchId'
                                        }
                                    ]
                                },
                                {},
                                {},
                                {}
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                        },
                        {
                            id: 'status',
                            type: 'select',
                            label: Core.Definition.getDefinition('État'),
                            onSelect: function() {}
                        },
                        {
                            id: 'start',
                            type: 'date',
                            label: Core.Definition.getDefinition('Début'),
                        },
                        {
                            id: 'end',
                            type: 'date',
                            label: Core.Definition.getDefinition('Fin'),
                        },
                        {
                            id: 'purchaseId',
                            type: 'number',
                            label: Core.Definition.getDefinition('ID de l\'achat'),
                            value: ''
                        },
                        {
                            id: 'purchaseType',
                            type: 'select',
                            label: Core.Definition.getDefinition('Type de l\'achat'),
                            value: '',
                            onSelect: function() {}
                        },
                        {
                            id: 'referenceNumber',
                            type: 'text',
                            label: Core.Definition.getDefinition('Numéro de référence'),
                            value: ''
                        },
                        {
                            id: 'method',
                            type: 'select',
                            label: Core.Definition.getDefinition('Méthode de paiement'),
                            value: '',
                            onSelect: function() {}
                        },
                        {
                            id: 'branchId',
                            type: 'multiSelect',
                            _isVisible: Core.Session.AuthUser.can('report_multiple_branch') && Core.Session.isPrimaryBranch(),
                            label: Core.Definition.getDefinition('Établissement'),
                            value: null,
                            onSelect: function() {
                            }
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataCharts: false
            }
        },
        methods: {
            onExport() {
                let searchArgs = this.$refs.dynamicCardList.$refs.request.dataArgs
                for(let searchArg in searchArgs) {
                    searchArg = searchArgs[searchArg]
                    this.$refs.modalExport.$refs.request.addArg(searchArg.key, searchArg.value, searchArg.type)
                }
            },
            onRetrieve(data) {
              if(data !== undefined && data.charts !== undefined) {
                  this.dataCharts = data.charts
              }
            },
            clickEdit(value, cell, row) {
                switch(row.purchaseType) {
                    case Core.Product.typeOrder:
                    case Core.Product.typeStandard:
                        this.$router.push(Core.Definition.getDefinition('/commerce/commandes/' + row.purchaseId))
                        break
                    case Core.Product.typeLimitedSubscription:
                        this.$router.push(Core.Definition.getDefinition('/commerce/abonnements-limites/' + row.purchaseId))
                        break
                    case Core.Product.typeRecurringSubscription:
                        this.$router.push(Core.Definition.getDefinition('/commerce/abonnements-recurrents/' + row.purchaseId))
                        break
                }
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
